import { apiRequest } from '../services/apiClient';

const BASE = '/gateway/api/ticket/inquiry-responsible-role-capacities';

const inquiryResponsibleRoleCapacityService = {
  async search({ search = '', status, page = 0, size = 10 } = {}) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('size', String(size));
    if (search && search.trim()) params.set('search', search.trim());
    if (status === true || status === false) params.set('status', String(status));
    const response = await apiRequest(`${BASE}?${params.toString()}`, { method: 'GET' });
    return response?.data ?? response;
  },

  async getAll(status) {
    const params = new URLSearchParams();
    if (status === true || status === false) params.set('status', String(status));
    const qs = params.toString();
    const response = await apiRequest(`${BASE}/all${qs ? `?${qs}` : ''}`, { method: 'GET' });
    return response?.data ?? response;
  },

  async create(payload) {
    const response = await apiRequest(BASE, { method: 'POST', body: payload });
    return response?.data ?? response;
  },

  async update(id, payload) {
    const response = await apiRequest(`${BASE}/${id}`, { method: 'PUT', body: payload });
    return response?.data ?? response;
  },

  async updateStatus(id, status) {
    const response = await apiRequest(`${BASE}/${id}/status`, {
      method: 'PATCH',
      body: { status }
    });
    return response?.data ?? response;
  }
};

export default inquiryResponsibleRoleCapacityService;
